module.exports = __webpack_public_path__ + "static/media/Assassin.4e5af234.jpg";